import React, { useEffect, useState } from "react";
import { withNamespaces } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { some } from "lodash";
import "~/pages/Easypay/assets/css/styles.css";
import iconWarning from "~/pages/Easypay/assets/img/icons/icon-warning.png";
import easypayLogo from "~/pages/Easypay/assets/img/logos/easypay-logotipo.png";
import unikLogo from "~/assets/img/logos/unik-logo.png";
import "~/pages/Easypay/assets/scss/_backofficeEasypay.scss";
import BackOfficeInput from "~/pages/Easypay/components/BackOfficeInput";
import Header from "~/pages/Easypay/components/Header";
import Link from "~/pages/Easypay/components/Link";
import Table from "~/pages/Easypay/components/Table";
import TabSeparator from "~/pages/Easypay/components/TabSeparator";
import TabSeparatorWrapper from "~/pages/Easypay/components/TabSeparatorWrapper";
import Tag from "~/pages/Easypay/components/Tag";
import Spinner from "~/pages/Easypay/components/Spinner";

import {
  getAllUsers,
  getDocumentCoresystem,
} from "~/store/ducks/onboarding/actionTypes";

const BackofficeOrganization = ({ t, application }) => {
  const history = useHistory();
  const dispatch = useDispatch();

  const { users, isLoadingGetAllUsers, apiSettings } = useSelector(
    (state) => state.onboardingReducer
  );
  const { user } = useSelector((state) => state.globalReducer);

  useEffect(() => {
    users.length > 0 && setFilteredList(filterUsers(users));
  }, [users]);

  const filterUsers = (list) =>
    list.filter((user) => user?.account?.lead === 1);

  const [filteredList, setFilteredList] = useState([]);

  const [tableSize, setTableSize] = useState(10);

  const [filters, setFilters] = useState([
    { type: "", value: "" },
    { type: "", value: "" },
    { type: "", value: "" },
    { type: "", value: "" },
    { type: "", value: "" },
    { type: "", value: "" },
    { type: "", value: "" },
    { type: "", value: "" },
  ]);

  var isFirstTime = true;

  useEffect(() => {
    if (isFirstTime) {
      window.scrollTo(0, 0);
      isFirstTime = false;
    }
    dispatch(getAllUsers());
    dispatch(
      getDocumentCoresystem(
        "3aa5097a9f264f7dacb8c1b6e87bb9e4",
        "61798db3a0ac1d6257017e87"
      )
    );
  }, []);

  const idFormatterLeads = (cell, row) => {
    if (
      (row.client.departamento === "Comercial" &&
        some(user.roles, { label: "ONBOARDINGComercial" })) ||
      (row.client.departamento === "Compliance" &&
        some(user.roles, { label: "ONBOARDINGCompliance" })) ||
      some(user.roles, { label: "ADMIN" }) ||
      some(user.roles, { label: "ONBOARDINGUser" })
    ) {
      return (
        <Link
          text={cell}
          onClick={() =>
            history.push({
              pathname: `/uniksystem/onboarding/backoffic-organization/leads/${cell}`,
            })
          }
        />
      );
    } else
    return cell
  };
  /*  const statusFormatter = () => {
    return <img src={iconWarning} />;
  }; */

  const resultFormatter = (cell, row) => {
    return (
      <Tag
        text={cell ? Math.round(cell * 20) : 0}
        variant="easypay-tag-label"
        type={`${
          row?.account?.mediaRiskScoring <= 3.75 && cell
            ? "easypay-approved"
            : "easypay-evaluation"
        } `}
      />
    );
  };

  const stageFormatter = (cell) => {
    return cell;
  };

  const dateFormatter = (cell) => {
    if (!cell) {
      return cell;
    }
    const dateAux = new Date(cell);
    return dateAux
      .getUTCDate()
      .toString()
      .concat("-", dateAux.getMonth() + 1, "-", dateAux.getFullYear());
  };

  const capitalizeText = (cell) =>
    cell ? cell.charAt(0).toUpperCase() + cell.slice(1) : "";

  const accountFormatter = (cell) => {
    if (cell) {
      return cell.charAt(0).toUpperCase();
    }
  };

  const statusFormatter = (cell) => {
    const index = filteredList.findIndex((object) => {
      return object.account.pid === cell;
    });
    const currentUser = filteredList[index];

    if (currentUser?.account?.aprovado != 1) {
      return <img src={iconWarning} />;
    } else if (currentUser.account.estadoLead != "PDA_REC ") {
      return <img src={iconWarning} />;
    } else if (currentUser?.client?.hasDocRejected != 0) {
      return <img src={iconWarning} />;
    }
    return <div></div>;
  };

  const columns = [
    {
      dataField: "client.pid",
      text: "",
      formatter: statusFormatter,
      headerStyle: { width: "40px", whiteSpace: "normal" },
    },
    {
      dataField: "client.pid",
      text: t("bpm.onboarding.backoffice.administration.tableIdLead"),
      sort: true,
      formatter: idFormatterLeads,
      sortValue: (cell) => parseInt(cell),
      headerStyle: { width: "110px" },
    },
    {
      dataField: "client.nome",
      text: t("bpm.onboarding.backoffice.administration.tableNameLead"),
      sort: true,
      headerStyle: { whiteSpace: "normal", width: "140px" },
    },
    {
      dataField: "account.tipoConta",
      text: t("bpm.onboarding.backoffice.administration.tableAccount"),
      sort: false,
      headerStyle: { width: "80px" },
      formatter: accountFormatter,
    },
    {
      dataField: "client.numTelemovel",
      text: t("bpm.onboarding.backoffice.administration.tablePhone"),
      sort: false,
    },
    {
      dataField: "client.email",
      text: t("bpm.onboarding.backoffice.administration.tableEmail"),
      sort: false,
    },
    {
      dataField: "client.parceiro",
      text: t("bpm.onboarding.backoffice.administration.tablePartner"),
      sort: false,
    },
    {
      dataField: "account.createdDate",
      text: t("bpm.onboarding.backoffice.administration.tableCreationDate"),
      sort: true,
      headerStyle: { whiteSpace: "normal" },
      formatter: dateFormatter,
    },
    {
      dataField: "account.createdBy",
      text: t("bpm.onboarding.backoffice.administration.tableCreatedBy"),
      sort: false,
      headerStyle: { whiteSpace: "normal" },
      formatter: capitalizeText,
    },
    {
      dataField: "client.departamento",
      text: t("bpm.onboarding.backoffice.administration.tableDepartment"),
      sort: false,
      headerStyle: {
        whiteSpace: "normal",
        overflow: "wrap",
      },
    },
    {
      dataField: "account.estadoLead",
      text: t("bpm.onboarding.backoffice.administration.tableStage"),
      sort: false,
      formatter: stageFormatter,
      headerStyle: {
        width: "80px",
      },
    },
  ];

  if (!some(user.roles, { label: "ONBOARDINGComercial" })) {
    columns.push({
      dataField: "account.mediaRiskScoring",
      text: t("bpm.onboarding.backoffice.administration.tableResult"),
      sort: false,
      formatter: resultFormatter,
    });
  }

  //filters all the data using the filters, this runs anytime the filter is changed and has a different value from previous state
  const filterData = (data, filter) => {
    const validFilters = filter.filter((e) => e.value !== "");
    if (validFilters.length > 0) {
      const filteredData = data.filter((user) => {
        console.log(user);
        //Looping in each user for all filters. returns false if at least one filter value is not found for better performance
        for (let i = 0; i < validFilters.length; i++) {
          if (
            validFilters[i].value.length === 2 &&
            typeof validFilters[i].value === "object"
          ) {
            //Date input takes multiple values
            const userDate = new Date(
              user[validFilters[i].type[0]?.split(".")[0]][
                validFilters[i].type[0]?.split(".")[1]
              ]
            ).getTime();
            const startDate = validFilters[i].value[0];
            const endDate = validFilters[i].value[1];
            if (userDate) {
              if (startDate <= userDate && userDate <= endDate) {
              } else {
                return false;
              }
            } else {
              return false;
            }
          } else if (validFilters[i].type.length === 3) {
            //Search input takes multiple types
            const userParam1 =
              user[validFilters[i].type[0]?.split(".")[0]][
                validFilters[i].type[0]?.split(".")[1]
              ]?.toString();
            const userParam2 =
              user[validFilters[i].type[1]?.split(".")[0]][
                validFilters[i].type[1]?.split(".")[1]
              ]?.toString();
            const userParam3 =
              user[validFilters[i].type[2]?.split(".")[0]][
                validFilters[i].type[2]?.split(".")[1]
              ]?.toString();
            if (
              !userParam1
                ?.toUpperCase()
                ?.includes(validFilters[i].value.toUpperCase()) &&
              !userParam2
                ?.toUpperCase()
                ?.includes(validFilters[i].value.toUpperCase()) &&
              !userParam3
                ?.toUpperCase()
                ?.includes(validFilters[i].value.toUpperCase())
            ) {
              return false;
            }
          } else {
            if (
              user[validFilters[i].type[0]?.split(".")[0]][
                validFilters[i].type[0]?.split(".")[1]
              ]
                ?.toString()
                .toUpperCase() !==
              validFilters[i].value.toString().toUpperCase()
            ) {
              return false; //case where user does not have at least one filter value (going to return false for data.filter function)
            }
          }
          if (i === validFilters.length - 1) {
            return true;
          }
        }
        return false;
      });
      return filteredData;
    } else {
      return data; //in case there's no filter applied returns data unfiltered
    }
  };

  //these are called when an input from /BackOfficeInput is changed, they alter the filters
  const setFiltersHandler = (filter, filterNum) => {
    if (filters[filterNum]?.value !== filter.value) {
      setFilters((prev) => {
        const newFilter = [...prev];
        newFilter[filterNum] = filter;
        return newFilter;
      });
    }
  };

  return (
    <div style={{ overflowY: "scroll", width: "100%", minHeight: "100%" }}>
      <Header
        redirect={true}
        logo={
          !application
            ? ""
            : application?.applicationName === "easypay"
            ? easypayLogo
            : unikLogo
        }
        height={application?.applicationName === "easypay" ? "30px" : "40px"}
        exit={"#/uniksystem/onboarding/integrations"}
        hideExtraLinks={true}
      />

      <div className="easypay-backoffice-content easypay-backoffice-tab">
        <TabSeparatorWrapper>
          <TabSeparator text="Leads" name="tab1">
            <BackOfficeInput
              firstDropdownLabel={t(
                "bpm.onboarding.backoffice.administration.tableAccount"
              )}
              firstDropdownFilter={"account.tipoConta"}
              filterDate={"account.createdDate"}
              filterCreatedBy={"account.createdBy"}
              filterDepartment={"account.departamento"}
              filterPhase={"account.estadoLead"}
              filterResult={"client.resultadoScoringQuestionario"}
              filterColor={"account.cor"}
              tableData={filterData(filteredList, filters)}
              onSetFilters={setFiltersHandler}
              savedFilters={filters}
              key={"leads-input"}
              disabled={isLoadingGetAllUsers && Object.keys(users).length === 0}
            />
            <Table
              sort={{ dataField: "client.pid", order: "desc" }}
              docs={filterData(filteredList, filters)}
              columns={columns}
              tableSize={tableSize}
              setTableSize={setTableSize}
              key="leads-table"
            />
          </TabSeparator>
          <TabSeparator
            text="Onboarding"
            name="tab2"
            redirect={
              "/#/uniksystem/onboarding/backoffic-organization/onboarding"
            }
          />
          <TabSeparator
            text="Documentos"
            name="tab3"
            redirect={
              "/#/uniksystem/onboarding/backoffic-organization/documents"
            }
          />
        </TabSeparatorWrapper>
      </div>
      <Spinner
        spinning={Object.keys(users).length === 0 && isLoadingGetAllUsers}
      />
    </div>
  );
};
export default withNamespaces()(BackofficeOrganization);
